import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import * as actions from "../../Actions/sendToClient";
import PropTypes from 'prop-types';
import ModalsHeader from '../Modals/ModalsHeader';
import axios from 'axios';
import moment from 'moment';
import papa from 'papaparse';
import { Button, Checkbox } from '@material-ui/core';
import classes from '../Modals/./Modals.css';
import { ROOT_URL } from '../../Actions/types';
import NativeSelect from '@material-ui/core/NativeSelect';

function formatCurrency(amount) {
  return `$${amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}

const SendToClientModal = (props) => {

    const [sendToClientFormData, setSendToClientData] = useState({
      targetEmail: '',
      message: '',
      sendTransactions: false,
    });

    const handleInputChange = (event) => {
      console.log('input change event.');
      const { name, } = event.target;
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      setSendToClientData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    };

    const handleSendToClient = (values) => {
      sendToClientFormData.message += "<br/><br/>The transactions to be reviewed include:<br/></br>";

      for (let i = 0; i < props.selectedTransactions.length; i++) {
        sendToClientFormData.message += "<b>Date:</b> " + props.selectedTransactions[i].TransactionDate + "<br/>"
        + "<b>Narration:</b> " + props.selectedTransactions[i].Description + "</br><b>Amount:</b> " + formatCurrency(props.selectedTransactions[i].Amount) + "<br/></br>";
      }

      props.sendTransactionsToClient(sendToClientFormData.targetEmail, sendToClientFormData.message);
      props.closeModal();
    }

    return (
        <div className={classes.container}>
            <h3>Send Transactions to user</h3>
            <div className={classes.infoBox}>
                <p className={classes.smallGey}>This will send an e-mail containing a link to a filtered
                  <br/> view of this page showing the currently highlighted transactions
                  <br/><br/> (Only users with access to this book appear as options.)</p>
            </div>
            <br/>

            <label>Send to:</label>
            <NativeSelect
            onChange={handleInputChange}
            name="targetEmail"
            className={classes.select}
            value={sendToClientFormData.targetEmail}
            inputProps={{ 'aria-label': 'sendTo' }} >
                <option value="">Select user...</option>
                <option value="james.simpson+scclient@reckon.com">James Simpson</option>
            </NativeSelect><br/>
            <Checkbox name="sendTransactions" onChange={() => handleInputChange} value ={sendToClientFormData.sendTransactions}/> Include Transaction Details
            <br/>
            <br/>
            <label>Message:</label>
            <textarea
              name="message"
              placeholder="Use this to include a personalized message"
              maxLength={500}
              rows={5}
              value={sendToClientFormData.message}
              onChange={handleInputChange}
            />
            <label htmlFor="contained-button-file">
                <Button variant="contained" color="primary" component="span" className={classes.button} onClick={handleSendToClient}>Send</Button>&nbsp;&nbsp;&nbsp;
                <Button variant="contained" className={classes.button} onClick={props.closeModal}>Cancel</Button>
            </label>
      </div>
    )
  }

SendToClientModal.propTypes = {
    handleSendToClient: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        comments: state.comments,
        status: state.status,
        transactionsList: state.transactions.transactionsList
    };
}
export default connect(mapStateToProps, actions)(SendToClientModal);


// WEBPACK FOOTER //
// ./src/components/SendTransactions/SendTransactions.js